module.exports = __webpack_public_path__ + "static/media/Dosis-Regular.f955f2f8.ttf";